<template>
  <v-dialog persistent v-model="value" max-width="700px" scrollable>
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">Crear subgrupo</span>
      </v-card-title>
      <v-card-text style="max-height: 700px;">
        <v-layout wrap>
          <v-flex xs12>
            <v-stepper v-model="e1" class="elevation-0">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" :step="1">Subgrupo</v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="e1 > 2" :step="2">Días</v-stepper-step>
                <v-divider />
                <v-stepper-step :step="3">Previo</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :step="1">
                  <SubgroupData 
                    :v="$v.subgroupForm" 
                    :subgroup="subgroupForm"
                    :levels="this.levels" 
                  /> 
                </v-stepper-content>
                <v-stepper-content :step="2">
                  <SubgroupNumberDays :subgroup="subgroupForm" />
                </v-stepper-content>
                <v-stepper-content :step="3">
                  <SubgroupDetail :subgroup="subgroupForm" />
                </v-stepper-content>
              </v-stepper-items>
              <alert 
                v-model="toast.alert" 
                title="Error al crear"
                :description="toast.description"
              />
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="disabled" :disabled="e1 == 1" color="primary" @click="back" icon>
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="disabled" @click="close" flat>Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="disabled" color="primary" @click="next" icon>
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { required } from "vuelidate/lib/validators";
import alert from "../../Dialogs/Alert";
import SubgroupData from "./SubgroupData";
import SubgroupNumberDays from "./SubgroupNumberDays";
import SubgroupDetail from "./SubgroupDetail";
import moment from "moment";

export default {
  components: {
    alert,
    SubgroupData,
    SubgroupNumberDays,
    SubgroupDetail
  },
  validations: {
    subgroupForm: {
      name: { required },
      level: { required },
      idLevel: { required },
      grade: { },
      idGradeGroup: { required },
      divider: { required },
      order: { required }
    },
  },
  props: ["value","levels"],
  watch: {
    value() {
      if (this.value && this.flags.cancel) {
        this.flags.cancel = false;
      }
    }
  },
  data: () => ({
    e1: 0,
    subgroupForm: {
      name: "",
      level: "",
      idLevel: "",
      grade: "",
      idGradeGroup: "",
      start: "",
      end: "",
      divider: "",
      order: "",
      days: []
    },
    toast: {
      alert: false,
      description: "Asegúrate de asignar un periodo válido y un horario a todos los grupos que deseas crear",
    },
    flags: {
      cancel: false,
      loading: false,
    },
    disabled: true
  }),
  methods: {
    close() {
      this.subgroupForm = {
        name: "",
        level: "",
        idLevel: "",
        grade: "",
        idGradeGroup: "",
        divider: "",
        order: "",
        start: "",
        end: "",
        days: []
      };
      this.flags.cancel = true;
      this.e1 = 1;
      this.$v.subgroupForm.$reset();
      this.$emit("onClosed", false);
    },
    next() {
      switch (this.e1) {
        case 1:
          this.$v.subgroupForm.level.$touch();
          this.$v.subgroupForm.grade.$touch();
          this.$v.subgroupForm.divider.$touch();
          this.$v.subgroupForm.order.$touch();

          if (!this.$v.subgroupForm.level.$invalid && !this.$v.subgroupForm.grade.$invalid 
            && !this.$v.subgroupForm.divider.$invalid && !this.$v.subgroupForm.order.$invalid) {
            this.e1++;
          }
          console.log(this.subgroupForm)

          break;
        case 2:
          if (this.validDays()) {
            this.e1++;
          } else {
            this.toast.alert = true;
          }
          console.log(this.subgroupForm)
          break;
        case 3:
            this.createSubgroup();
            break        
      }
    },
    validDays(){
        
        var days = [];
        this.subgroupForm.days.forEach((day, index) => {
            if (!day.monday && !day.tuesday && !day.wednesday && !day.thursday && 
                    !day.friday && !day.saturday && !day.sunday 
                    // || (!day.start || !day.end)
                ) 
            {
                days.push(index + 1);
            }
        });

        return days.length == 0;
    },
    back() {
      this.e1--;
    },
    createSubgroup() {
      this.disabled = false;
      this.$emit("loading", true);

      var subgroup = {
        idLevel: this.subgroupForm.level.id,
        idGradeGroup: this.subgroupForm.grade.id,
        days: this.subgroupForm.days.map(d => {
          const nd = Object.assign({}, d);
          delete nd.startDate;
          delete nd.startError;
          delete nd.endDate;
          delete nd.endError;
          return nd;
        }),
        orderBy: this.subgroupForm.order,
      };

     
      this.$store
        .dispatch("subgroups/createSubgroup", subgroup)
        .then((response) => {
          this.disabled = true;
          this.$v.subgroupForm.$reset();
          this.close();
          this.$emit("created", { success: true, poll: response.data });
        })
        .catch((error) => {
          this.disabled = true;
          this.$emit("created", { success: false, error: error });
        });
    }
  },
  computed: {
  }
};
</script>

<style>

.v-card__text #container .container{
  padding: 0 !important;
}
</style>
